import { resolveRelationshipWrites } from '@griply/services';
import { RelationshipUpdate } from '@griply/types';
import { useCallback } from 'react';
import { useCreateRelationshipsMutation } from 'shared/hooks/queries/use-create-relationships-mutation';
import { useUpdateRelationshipsReferencesMutation } from 'shared/hooks/queries/use-update-relationships-references-mutation';
import { useRelationships } from 'shared/hooks/use-relationships';

export const useUpdateRelationshipsReferences = () => {
  const { mutate: updateRelationships } =
    useUpdateRelationshipsReferencesMutation();
  const { mutate: createRelationships } = useCreateRelationshipsMutation();
  const relationships = useRelationships();

  return useCallback(
    (relationshipUpdates: RelationshipUpdate[]) => {
      const { toCreate, toUpdate } = resolveRelationshipWrites(
        relationshipUpdates,
        relationships,
      );

      if (toCreate.length) {
        createRelationships(toCreate);
      }

      if (toUpdate.length) {
        updateRelationships(toUpdate);
      }
    },
    [createRelationships, relationships, updateRelationships],
  );
};
